module.exports = __webpack_public_path__ + "c052fe141c3d306702e3ca0f8dbc718a.jpg";